/**
 * Created by hejikun on 2017/10/30 0030.
 */
import Router from 'vue-router'
import Vue from 'vue'
import routes from './routes'
import store from '../store'
import { Base64 } from 'js-base64'
import wx from 'weixin-js-sdk'
const mode = 'history'
const hashbang = true

const router = new Router({
  hashbang,
  mode,
  routes,
  base: '/'
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
Vue.use(Router)

// 处理 channel 添加逻辑
function channelNext (to, query, from, next) {
  const wxPlatform = localStorage.getItem('wxPlatform') // 1: 滇医通新服务号 2: 滇医通小程序 3: 滇医通老服务号
  if (query) {
    if (to.path.indexOf('/ucenter_appointment_order_details') > -1 ||(to.path.indexOf('/registration_doctor_list_new') > -1 || to.path.indexOf('/registration_doctor_detail_new') > -1 || to.path.indexOf('/ucenter_col_doc') > -1) && !to.query.channel && wxPlatform === '1') {
      return next({
        path: to.path,
        query: {
          ...to.query,
          ...query,
          channel: localStorage.getItem('channel') || '2'
        }
      })
    } else {
      return next({
        path: to.path,
        query: {
          ...to.query,
          ...query
        }
      })
    }
  }
  return next()
}

// 处理小程序重构路由跳转逻辑
function handleMiniProgram(to, from, next) {
  // 判断当前环境为小程序环境
  const isMiniProgram = localStorage.getItem('is_wx') === '1'
  if (!isMiniProgram) {
    return true
  }
  const routeMap = store.getters.getRouteMap
  // 判断 to 路径是否有映射的已重构的小程序路径
  // 有则跳转到小程序
  // 无则继续
  const route = routeMap.find(item => item.h5 === to.path)
  if (route) {
    // 跳转到小程序 h5 端不再执行跳转
    let url = route.mp
    if (to.query && Object.keys(to.query).length > 0) {
      url += '?' + Object.keys(to.query).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(to.query[key])}`).join('&')
    }
    wx.miniProgram.navigateTo({
      url,
      fail(e) {
        console.log('跳转失败', e)
      }
    })
    return false
  }
  return true
}

router.beforeEach((to, from, next) => {
  console.log('from: ', from);
  console.log('to: ', to);
  if(from.path.indexOf('ask2ChatRoom') >= 0 && to.path.indexOf('/news') >= 0 && !to.query.tabIndex){
    channelNext(to,{
      tabIndex: -1,
    },from,next)
    return
  }
  if (!handleMiniProgram(to, from, next)) {
    next(false)
    return
  }
  // 对昆华进行特殊处理
  // 1.含有#特殊字符的path 会导致query无法解析 进行手动解析后传递
  let isHashChange = false
  const queryParams = {}
  if(to.hash != ''){
    const queryStringMatch = to.fullPath.match(/\?(.*)$/);
    console.log('const queryStringMatch lms', queryStringMatch);
    const queryString = queryStringMatch[1];
    console.log('lms1');

    queryString.split('&').forEach((param) => {
      const [key, value] = param.split('=');
      console.log('lms2');
      queryParams[key] = value ? decodeURIComponent(value) : null;
      // if (value && decodeURIComponent(value).includes('#')) {
      //   // 对含有 `#` 的参数进行特殊处理
      //   const [beforeHash, afterHash] = decodeURIComponent(value).split('#');
      //   queryParams[key] = beforeHash; // 设置 `#` 之前的部分

      //   // 如果有 `#` 后的内容，将其解析到额外的 query 参数
      //   if (afterHash) {
      //     queryParams[`${key}`] = beforeHash+afterHash;
      //   }
      // } else {
      //   // 普通参数，直接解析
      //   queryParams[key] = value ? decodeURIComponent(value) : null;
      // }
    });
    console.log("queryParams lms",queryParams);
    isHashChange = true
  }
  if (to.path == '/ucenter_add_patient_new' && from.path !== '/ucenter_add_patient_h5') {
    localStorage.setItem('patiend_from', from.fullPath)
  }
  if (navigator.userAgent.indexOf('AliApp') > -1) {
    // 动态加载脚本，其源设置为 "https://appx/web-view.min.js"
    if (window.my) {
      window.my.postMessage({
        name: 'bj',
        obj: {
          title: to.name,
          url: 'https://appv3.ynhdkc.com' + to.fullPath
        }
      })
    }
  }
  // 百度统计
  let fromChannel = to.query.from_channel
  if (to.path.indexOf('/home') > -1) {
    let flag = false
    if (sessionStorage.getItem('fromCsfw') === 'dytminiapp') {
      flag = true
    }
    // window.track('assist_router', encodeURIComponent(JSON.stringify({ to: flag ? to.path + '?fromCsfw=dytminiapp' : to.path, from: from.fullPath })))
  } else {
    // window.track('assist_router', encodeURIComponent(JSON.stringify({ to: to.fullPath, from: from.fullPath })))
  }
  if (fromChannel) {
    sessionStorage.setItem('from_channel', fromChannel)
  }
  if (sessionStorage.getItem('fromCsfw') === 'dytminiapp') {
    window._hmt.push(['_trackPageview', to.path + '?fromCsfw=dytminiapp'])
  } else {
    window._hmt.push(['_trackPageview', to.path])
  }
  // 设置页面title
  if (window.utils) {
    if (to.path === '/physicalExamination_index' && to.query.id === '138') {
      window.utils.setTitle('陪诊服务')
    } else if (to.path === '/physicalExamination_inde_detail' && to.query.id === '138') {
      window.utils.setTitle('陪诊机构详情')
    } else if (to.path === '/physicalExamination_new_detail' && to.query.pz === '1') {
      window.utils.setTitle('陪诊订单详情')
    } else {
      window.utils.setTitle(to.name)
    }
  }
  let is_wx
  wx.miniProgram.getEnv((res) => {
    if (res.miniprogram) {
      // 在小程序
      is_wx = 0
    } else {
      // 在公众号
      is_wx = 1
    }
  })
  let data = localStorage.getItem('authtoken')
  if (
    !data &&
    from.path == '/home' &&
    to.path !== '/user_regiter'
    && is_wx == 1
  ) {
    next('/user_regiter')
  }
  try {
    const userInfo = JSON.parse(window.Base64.decode(data.split('.')[1]))
    const channel = localStorage.getItem('channel') || '2'
    if (to.path !== '/user_regiter' && ((channel === '1' && !userInfo.openid) || (channel === '2' && !userInfo.new_openid))) {
      next('/user_regiter')
    }
  } catch (error) {}
  let isNavigating = false
  store.commit('set_popup_show', false)
  // 否则，我们允许他们访问他们试图访问的页面
  if (sessionStorage.getItem('fromCsfw') === 'dytminiapp' && to.hash !== '#wechat_redirect') {
    // next({ path: to.path + '#wechat_redirect', params: to.params, query: to.query })
    if (isNavigating) {
      // 可以添加一些提示用户的逻辑
      return
    }
    isNavigating = true
    const currentPath = from.path
    // 获取即将跳转的路由地址
    const nextPath = to.path

    // 如果当前的路由地址和即将跳转的路由地址相同，则不执行导航
    if (currentPath === nextPath) {
      // 不执行导航
      return
    }
    if(isHashChange){
      isNavigating = false
      channelNext(to, queryParams, from, next)
    }else{
      isNavigating = false
      channelNext(to, null, from, next)
    }
  } else {
    if (isNavigating) {
      // 可以添加一些提示用户的逻辑
      return
    }
    isNavigating = true
    const currentPath = from.path
    // 获取即将跳转的路由地址
    const nextPath = to.path
    // 如果当前的路由地址和即将跳转的路由地址相同，则不执行导航
    if (currentPath === nextPath) {
      // 不执行导航
      return
    }
    if(isHashChange){
      isNavigating = false
      channelNext(to, queryParams, from, next)
    }else{
      isNavigating = false
      channelNext(to, null, from, next)
    }
  }
  if (navigator.userAgent.indexOf('Alipay') > -1 || navigator.userAgent.indexOf('AlipayClient') > -1) {
    if (!data && from.path == '/home_new') {
      window.AlipayJSBridge.call(
        'alert',
        {
          message: '用户未注册或授权过期,请点击授权~',
          button: '确定'
        },
        function (e) {
          let data = localStorage.getItem('authtoken')
          if (data) {
            // eslint-disable-next-line no-undef
            my.redirectTo({
              url: `/pages/index/index`
            })
          } else {
            // eslint-disable-next-line no-undef
            my.redirectTo({
              url: '/pages/login/login'
            })
          }
        }
      )
    }
  }
})
router.afterEach(() => {
  store.commit('set_popup_show', false)
})
window.$router = router

export default router
